import { getActiveProfile, getActiveTeam } from '../services/profileService';
import { isTeamOwnerOrAdmin } from '../types/profile';

// SVG icon imports from assets folder
import dashboardIcon from '@/assets/Dashboard.svg';
import coursesIcon from '@/assets/Courses.svg';
import mysteryShopIcon from '@/assets/Mystery Shop.svg';
import teamIcon from '@/assets/Team.svg';
import progressIcon from '@/assets/Progress.svg';
import resourceLibraryIcon from '@/assets/Resource Library.svg';

export interface MenuItem {
  label: string;
  path: string;
  icon: string; // SVG image path
  shouldShow?: () => boolean;
  isMain?: boolean;
}

export const menuItems: MenuItem[] = [
  { label: 'Home', path: '/dashboard', icon: dashboardIcon, isMain: true },
  { label: 'Courses', path: '/all-courses', icon: coursesIcon, isMain: true },
  {
    label: 'Mystery Shops',
    path: '/mystery-shop',
    icon: mysteryShopIcon,
    isMain: true,
    shouldShow: () => {
      const profile = getActiveProfile();
      const team = getActiveTeam();
      return !!(profile && team && isTeamOwnerOrAdmin(profile));
    }
  },
  {
    label: 'My Team',
    path: '/my-team',
    icon: teamIcon,
    shouldShow: () => {
      const profile = getActiveProfile();
      const team = getActiveTeam();
      return !!(profile && (!profile.businessId || (team && isTeamOwnerOrAdmin(profile))));
    }
  },
  { label: 'My Progress', path: '/my-progress', icon: progressIcon },
  // { label: 'Certifications', path: '/certification-courses', icon: ribbonOutline },
  { 
    label: 'Resources', 
    path: '/resource-library', 
    icon: resourceLibraryIcon,
    shouldShow: () => import.meta.env.VITE_ENV !== 'prod'
  },
];
